<div class="c row fill" [ngClass]="((contents$ | async)?.length ?? 0) < 1 ? 'hide' : ''">
  <div class="custom-contents" *ngFor="let content of contents$ | async" style="width: 100%">
    <div class="custom-content" [innerHTML]="content.description | secureHtml"></div>
  </div>
</div>
